define('AwaLabs.ADA', [
    'Cart.Summary.View',
    'Facets.Browse.View',
    'Header.Menu.View',
    'Header.MiniCart.View',
    'Header.Profile.View',
    'Cart.AddToCart.Button.View',
    'ProductList.Control.View',
    'SocialSharing.Flyout.View',
    'SC.Configuration',
    'jQuery',
    'underscore'
], function ADA(
    CartSummaryView,
    FacetsBrowseView,
    HeaderMenuView,
    HeaderMiniCartView,
    HeaderProfileView,
    CartAddToCartButtonView,
    ProductListControlView,
    SocialSharingFlyoutView,
    Configuration,
    jQuery,
    _
) {
    'use strict';

    //Allow open estimates and promo code with keyboard
    CartSummaryView.prototype.initialize = _.wrap(CartSummaryView.prototype.initialize, function wrapSummary(fn) {
        var self = this;
        fn.apply(this, _.toArray(arguments).slice(1));
        this.on('afterViewRender', function afterViewRender() {
            self.$('.cart-summary-expander-head-toggle').keydown(function keyDown(e) {
                if (e.keyCode === 13) {
                    jQuery(this).click();
                }
            })
        })
    })

    _.extend(FacetsBrowseView.prototype, {
        events: _.extend(FacetsBrowseView.prototype.events, {
            'click [data-action="skip-to-results"]': 'scrollToResults'
        }),
        scrollToResults: function scrollToResults(e) {
            e.preventDefault();
            jQuery('html, body').animate({
                scrollTop: jQuery('.facets-facet-browse-items')
                    .attr('tabindex', '-1')
                    .focus()
                    .offset()
                    .top
            }, 200);

        }
    })

    _.extend(HeaderMiniCartView.prototype, {
        events: _.extend(HeaderMiniCartView.prototype.events, {
            'focusout .header-mini-cart': 'focusOutMiniCart'
        }),
        focusOutMiniCart: function focusOutMiniCart(e) {
            if (!this.$('.header-mini-cart').has(e.relatedTarget).length) {
                this.$('.header-mini-cart-menu-cart-link').attr('aria-expanded', 'false').parent().removeClass('open')
            }
        }
    })

    _.extend(HeaderProfileView.prototype, {
        events: _.extend(HeaderProfileView.prototype.events || {}, {
            'focusout .header-profile-menu-myaccount-container': 'focusOutMyAccount'
        }),
        focusOutMyAccount: function focusOutMyAccount(e) {
            if (!this.$('.header-profile-menu-myaccount-container').has(e.relatedTarget).length) {
                this.$('.header-profile-welcome-link').attr('aria-expanded', 'false').parent().removeClass('open')
            }
        }
    })

    _.extend(HeaderMenuView.prototype, {
        events: _.extend(HeaderMenuView.prototype.events, {
            'keydown .header-menu-level1-anchor': 'openMenuForADA',
            'focus .header-menu-level1-anchor': 'closeOtherMenus'
        }),
        closeOtherMenus: function closeOtherMenus(e){
            var $el = jQuery(e.currentTarget);
            var $siblings = $el.parent().siblings();
            $siblings.removeClass('open').find('a').attr('aria-expanded', 'false')
        },
        openMenuForADA: function openMenuForADA(e) {
            var $el = jQuery(e.currentTarget);
            var $parent = $el.parent();
            if (e.keyCode === 32) {
                e.preventDefault();
                $parent.toggleClass('open');
                $el.attr('aria-expanded', $parent.hasClass('open'))
            }
        }
    })

    CartAddToCartButtonView.prototype.getContext = _.wrap(CartAddToCartButtonView.prototype.getContext, function getContext(fn) {
        var context = fn.apply(this, _.toArray(arguments).slice(1));
        context.itemName = this.model.getItem().get('_name')
        return context;
    });

    ProductListControlView.prototype.getContext = _.wrap(ProductListControlView.prototype.getContext, function getContext(fn) {
        var context = fn.apply(this, _.toArray(arguments).slice(1));
        context.itemName = this.product.getItem().get('_name')
        return context;
    });

    SocialSharingFlyoutView.prototype.getContext = function getContext() {
      return {
          itemModel: this.parentView.model.getItem()
      }
    };

    return {
        changeTabs: function changeTabs(e){
            var target = e.target;
            var parent = target.parentNode;
            var grandparent = parent.parentNode;

            // Remove all current selected tabs
            parent
                .querySelectorAll('[aria-selected="true"]')
                .forEach(function forEachTabPanel(tabPanel){
                    tabPanel.setAttribute("aria-selected", false);
                });

            // Set this tab as selected
            target.setAttribute("aria-selected", true);

            // Hide all tab panels
            grandparent
                .querySelectorAll('[role="tabpanel"]')
                .forEach(function forEachTabPanel(tabPanel){
                    tabPanel.setAttribute("hidden", true)
                });

            // Show the selected panel
            grandparent.parentNode
                .querySelector('#' + target.getAttribute("aria-controls"))
                .removeAttribute("hidden");
        },
        changeTabsListener: function changeTabsListener(){
            var tabs = document.querySelectorAll('[role="tab"]');
            var tabList = document.querySelector('[role="tablist"]');
            var self = this;

            // Add a click event handler to each tab
            tabs.forEach(function eachTab(tab){
                tab.addEventListener("click", self.changeTabs);
            });

            // Enable arrow navigation between tabs in the tab list
            var tabFocus = 0;

            tabList && tabList.addEventListener("keydown", function keyDown(e){
                // Move right
                if (e.keyCode === 39 || e.keyCode === 37) {
                    tabs[tabFocus].setAttribute("tabindex", -1);
                    if (e.keyCode === 39) {
                        tabFocus++;
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                        // Move left
                    } else if (e.keyCode === 37) {
                        tabFocus--;
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }

                    tabs[tabFocus].setAttribute("tabindex", 0);
                    tabs[tabFocus].focus();
                }
            });
        },
        mountToApp: function mountToApp(application) {
            Configuration.bxSliderDefaults.infiniteLoop = false;
            var Layout = application.getLayout();
            var $Layout;
            var self = this;

            //Add tabindex -1 to avoid focus on modal
            Layout.on('afterAppendView', function afterAppendView(view) {
                if (view.inModal) {
                    $Layout = jQuery('#layout');
                    $Layout.attr('tabindex', '-1').attr('aria-hidden','true').addClass('unselectable')
                    Layout.$containerModal.find('a,button,input').first().focus();
                    Layout.$containerModal.find('.modal-first-tabindex').on('focus',function(){
                        Layout.$containerModal.find('a,button,input').last().focus();
                    })
                    Layout.$containerModal.find('.modal-last-tabindex').on('focus',function(){
                        Layout.$containerModal.find('a,button,input').first().focus();
                    })
                    Layout.$containerModal.on('hidden.bs.modal', function () {
                        $Layout.removeAttr('tabindex').removeAttr('aria-hidden').removeClass('unselectable')
                    });
                }

                self.changeTabsListener();
                jQuery('#loadingIndicator').attr('alt', 'Loading indicator');
            });


            //Navigate back on backspace
            jQuery('body').off('keyup').keyup(function (e) {
                if (!jQuery(e.target).is('input') && !jQuery(e.target).is('textarea') && !jQuery(e.target).is('select') && e.keyCode === 8) {
                    history.back();
                }
            });

            Layout.once('afterRender', function afterAppendView() {
                //Append language attribute
                jQuery('head').append('<link rel="alternate" hreflang="en-US" href="https://applejack.com"/>');
                //Create skip to main content
                jQuery('.skip-to-main-content').remove();
                jQuery('<button/>', {
                    'class': 'skip-to-main-content',
                    'text': _('Skip to main content').translate(),
                    'tabindex': '0'
                }).insertBefore('#main')
                    .on('click', function onClick(e) {
                        e.preventDefault();
                        jQuery('html, body').animate({
                            scrollTop: jQuery('#main-container')
                                .attr('tabindex', '-1')
                                .focus()
                                .offset()
                                .top
                        }, 200);
                    });
                // Fix to avoid issues on tab first time.
                jQuery('body').click();

                CMS.on('page:content:set', function cmsRendered() {

                    self.changeTabsListener();

                    jQuery('img:not([alt])').each(function eachImage() {
                        jQuery(this).attr('alt', 'Image without description');
                    });

                    jQuery('a[href="#"]').each(function eachImage() {
                        jQuery(this).trigger('mousedown');
                    });

                    _.delay(function delayBxSliderChanges() {
                        jQuery('a[target=_blank]').off('click').on('click', function openExternalLink(e) {
                            if (!confirm('This link will open a new window')) {
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            }
                        })
                        Layout.currentView.$('.bx-pager-link').each(function eachPager() {
                            jQuery(this).attr('tabIndex', '-1');
                        })
                        Layout.currentView.$('.bx-viewport').each(function eachSlider() {
                            jQuery(this).removeAttr('aria-live').attr('aria-label', 'Carousel');
                        })

                        jQuery('.bx-pager-link').each(function eachPager() {
                            jQuery(this).attr('tabIndex', '-1');
                        })
                    }, 500)
                });

                CMS.once('page:content:set', function initSlider() {
                    var down = {};
                    var $body = jQuery('body');
                    var closeStores = false;

                    jQuery(document)
                        .off('keyup')
                        .off('keydown')
                        .on('keydown', function keyDown(e) {
                            if (e.keyCode === 9 && !$body.hasClass('ada')) {
                                $body.addClass('ada');
                            }
                            if (e.keyCode === 27) { // Hide Modals
                                e.preventDefault();
                                e.stopPropagation();
                                Layout.$containerModal && Layout.$containerModal.modal('hide');
                            } else {
                                down[e.keyCode] = true;
                            }
                        }).keyup(function (e) {
                            var $target = jQuery(e.target);
                            if (e.keyCode === 9) {
                                if($target.closest('.store-finder-content').length){
                                    closeStores = true;
                                }else{
                                    if(closeStores){
                                        closeStores = false;
                                        application.getLayout().$('#store-finder-container').dropdown('toggle');
                                    }
                                }
                            }
                            if (down[67] && down[77] && down[83]) { // 67:C 77:M 83:S
                                location.assign("/cms/3/admin/cms.jsp?from=" + encodeURIComponent(location.pathname + location.hash))
                            }
                            down[e.keyCode] = false;
                    });
                })
            })
        }
    };
});
